/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class VIPRLibraries
 * @classdesc
 */
define([
	'com/ibm/vida/control/vida'
], (vida) => {

	class VIPRLibraries  {
		constructor(options) {
			this.dashboardApi = options.dashboardApi;
		}

		setVIPRLibraries() {
			return Promise.all([
				this.dashboardApi.getCollectionExtension('com.ibm.bi.dashboard.vipr.visLibrary'),
				this.dashboardApi.getCollectionExtension('com.ibm.bi.dashboard.vipr.visLibrary.custom')
			]).then((viprLibraries) => {
				const libraries = {
					system: JSON.parse(JSON.stringify(viprLibraries[0])),
					custom: JSON.parse(JSON.stringify(viprLibraries[1]))
				};
				const featureChecker = this.dashboardApi.getGlassCoreSvc('.FeatureChecker');
				const userCapabilities = this.dashboardApi.getGlassCoreSvc('.UserProfile').capabilities;
				let hasPermission =  userCapabilities.indexOf('canDevelopVisualizations') !== -1 || featureChecker.checkValue('dashboard', 'canDevelopVisualizations', 'enabled');
				if (hasPermission) {
					const extendedVisPreview = libraries['custom'][0];
					extendedVisPreview.isCustomVis = true;
					const extendedSchematicPreview = libraries['custom'][1];
					extendedSchematicPreview.isSchematic = true;
					extendedVisPreview.location = vida.sdk.bundleLocation;
				} else {
					libraries['custom'].length = 0;
				}
				// When a glass collection item id is not fully qualified in the contrbution,
				// the id becomes fully qualified based on the collection id.
				// In this case fully qualified id is no longer a valid visId. An explicit visId must be used instead.
				// When a fully qualified visId is used as the collection item id, there is a chance the visId is used as an id elsewhere
				// as part of a different collection. In this case, the items will conflict regardless of it's owner collection.
				// And will end up having the conflicted collection items merged into each other.		
				for(let name in libraries) {
					libraries[name].forEach(lib => {
						if (lib.visId) {
							lib.id = lib.visId;
							delete lib.visId;
						}
					});
				}
				return libraries;
			});
		}

		static isSystemLib (libId, systemLibs = []) {
			const systemVis = systemLibs.find(lib => {
				return lib === libId;
			}) || null;

			return systemVis ? true : false;
		}
	}

	VIPRLibraries.LIB_TYPE_ALL = 'all_libs';
	VIPRLibraries.LIB_TYPE_SYSTEM = 'system_libs';
	VIPRLibraries.LIB_TYPE_CUSTOM = 'custom_libs';
	VIPRLibraries.LOAD_DEFINITION_ERROR = 'loadDefinitionError';

	return VIPRLibraries;
});
